// extracted by mini-css-extract-plugin
module.exports = {"baseStyle":"AnimatedButtonProvider_baseStyle__kWAnX","glow":"AnimatedButtonProvider_glow__1---s"};